module.exports = __webpack_public_path__ + "img/mode-prod--icon.acc6bc0c.svg";